import { render, staticRenderFns } from "./proUnit.vue?vue&type=template&id=4145cf92&scoped=true&"
import script from "./proUnit.vue?vue&type=script&lang=js&"
export * from "./proUnit.vue?vue&type=script&lang=js&"
import style0 from "./proUnit.vue?vue&type=style&index=0&id=4145cf92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4145cf92",
  null
  
)

export default component.exports